// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes appearFromSide {
  from {
    transform: translateX(20px) rotateZ(0.5turn);
    opacity: 0;
  }

  to {
    transform: translateY(0) rotateZ(0);
    opacity: 1;
  }
}
@keyframes appearFromTop {
  from {
    transform: scale(0.5) translateY(-20px);
    opacity: 0;
  }

  to {
    width: auto;
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
@keyframes disappearFromBottom {
  to {
    transform: scale(0.5) translateY(-20px);
    opacity: 0;
  }

  from {
    width: auto;
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@dhl-official/tokens/dist/css/semantics/animations.css"],"names":[],"mappings":"AAAA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,4CAA4C;IAC5C,UAAU;EACZ;;EAEA;IACE,mCAAmC;IACnC,UAAU;EACZ;AACF;AACA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,iCAAiC;IACjC,UAAU;EACZ;AACF;AACA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,iCAAiC;IACjC,UAAU;EACZ;AACF","sourcesContent":["@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes appearFromSide {\n  from {\n    transform: translateX(20px) rotateZ(0.5turn);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0) rotateZ(0);\n    opacity: 1;\n  }\n}\n@keyframes appearFromTop {\n  from {\n    transform: scale(0.5) translateY(-20px);\n    opacity: 0;\n  }\n\n  to {\n    width: auto;\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes disappearFromBottom {\n  to {\n    transform: scale(0.5) translateY(-20px);\n    opacity: 0;\n  }\n\n  from {\n    width: auto;\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
